import { render, staticRenderFns } from "./DialogEditUserInfo.pug?vue&type=template&id=5d38fa26&lang=pug&"
import script from "./DialogEditUserInfo.vue?vue&type=script&lang=js&"
export * from "./DialogEditUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports